<app-modal-container
  [buttons]="modalButtons"
  [bigSize]="true"
  [titleDirection]="'start'"
  [showWhiteSpace] = "true"
  [title]="'Edit organization'"
  [spinnerProps]="spinnerProps"
  [applyActivated]="orgForm?.valid"
  (applyButtonClicked)="confirm()"
  (closeButtonClicked)="close()"
  (dismissButtonClicked)="close()">
  @if (orgForm) {
    <div [formGroup]="orgForm" class="flex flex-col gap-[1rem] w-[23.625rem] h-[33.375rem]">
      <!-- Name -->
      <app-input
        data-qa="org-name"
        [formControlName]="'name'"
        [title]="'Name'"
        [required]="true"
      />

      <!-- Type -->
      <app-selector
        data-qa="org-type"
        [listEntryAdditionalClass]="'font-4'"
        [title]="'Type'"
        [formControlName]="'type'"
        [data]="Array.from(organizationTypes.values())"
        [triggerOnValueChange]="true"
        [selectedItem]="organizationTypes.get(orgForm.value?.type)"
        [isRequired]="true"
        (itemEmitter)="orgForm.controls.type.setValue(reversedOrganizationTypes.get($event))"
      />

      <!-- Country -->
      <app-selector-autocomplete
        data-qa="org-country"
        class="height-15 full-picker-width"
        [formControlName]="'country'"
        [title]="'Country'"
        [data]="countries"
        [selectedItem]="orgForm.value?.country"
      />

      <!-- Website -->
      <app-input
        data-qa="org-website"
        [formControlName]="'webSiteLink'"
        [title]="'Website'"
        [prefixText]="orgForm.value?.webSiteLink.includes('http') ? '' : 'https://'">
      </app-input>

      <!-- Logo Upload -->
      <app-upload
        #upload
        data-qa="logo-upload-input"
        [formControlName]="'logo'"
        [widthHeight]="'w-[100%] h-[9rem]'"
        [placeholder]="'Upload logo'"
        (deleteOldLink)="orgForm.patchValue({ logo: undefined })"
      />
      <app-button
        data-qa="delete-org"
        class="self-stretch"
        [size]="'medium'"
        [type]="'light-red'"
        [iconName]="'delete.svg'"
        [additionalClasses]="'w-full'"
        (buttonClick)="showModalDialog = true">
        Delete organization
      </app-button>
    </div>
  }
</app-modal-container>

@if (showModalDialog) {
  <app-modal-dialog
    [showIUnderstand]="true"
    [header]="'Delete organization'"
    [mainText]="[updatedOrganization.name + ' Organization' + ' will be deleted']"
    [useStandardList]="true"
    [addAdditionalText]="true"
    (isConfirmed)="deleteOrg($event)"
  />
}
